
/**
 * Arquivo de versão do sistema
 * Mantém o histórico de versões e informações sobre o lançamento atual
 */

export const VERSION = {
  number: '0.9.24',
  name: 'Elemento Ator',
  releaseDate: '2025-01-11',
  notes: 'Adição do novo elemento "Ator" ao editor de diagramas, permitindo representar pessoas/usuários com ícone personalizável, texto descritivo e conexões com outros componentes',
  buildTimestamp: __BUILD_TIMESTAMP__
};
